/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/restaurant'
export default icon
